import { CreateWorkflowV2Dto } from "@babackapp/private-api-client/types";
import { Workflow } from "../types";

/**
 * Creates a deep copy of a workflow with all new IDs
 * - Generates new trigger ID
 * - Generates new IDs for all nodes
 * - Updates all edge references to use new node IDs
 */
export function duplicateWorkflowWithNewIds(workflow: Workflow): {
  definition: CreateWorkflowV2Dto["definition"];
  trigger: CreateWorkflowV2Dto["trigger"];
} {
  const idMap = new Map<string, string>();

  const newTriggerId = crypto.randomUUID();
  idMap.set(workflow.trigger.id, newTriggerId);

  const duplicatedTrigger = {
    ...workflow.trigger,
    id: newTriggerId,
  };

  const duplicatedNodes = (workflow.definition?.nodes || []).map((node) => {
    const newId = crypto.randomUUID();
    idMap.set(node.id, newId);
    return { ...node, id: newId };
  });

  const duplicatedEdges = (workflow.definition?.edges || []).map((edge) => ({
    ...edge,
    id: crypto.randomUUID(),
    source: idMap.get(edge.source) || edge.source,
    target: idMap.get(edge.target) || edge.target,
  }));

  return {
    trigger: duplicatedTrigger,
    definition: {
      nodes: duplicatedNodes,
      edges: duplicatedEdges,
    },
  };
}
